import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

//
//component
//redux
//selector
import { bailiffDocumentStepSelector } from "store/bailiff/bailiff/document/bailiff_document.selector";
//actions
//utils
//hook
//str

export const FLOWS = {
  UPLOAD: "upload",
  PREVIEW: "preview",
  SUCCESS: "success",
};
export const useUploadFlow = () => {
  // -------------------------- VAR -----------------------------
  const [flow, setFlow] = useState(FLOWS.UPLOAD);
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const step = useSelector(bailiffDocumentStepSelector);
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (step === 0) {
      setFlow(FLOWS.UPLOAD);
    }
    if (step === 1) {
      setFlow(FLOWS.PREVIEW);
    }
    if (step === 2) {
      setFlow(FLOWS.SUCCESS);
    }
  }, [step]);
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { flow };
};
